import { render, staticRenderFns } from "./TagRedirect.vue?vue&type=template&id=35d9067c"
import script from "./TagRedirect.vue?vue&type=script&lang=js"
export * from "./TagRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports